import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import useHttp from "../../../hook/use-http";
import ChartLoader from "./ChartLoader";
import WaterMark from "../DashboardMain_Orion/WaterMark";
import './CriticalCustom_Orion.css';
import NoData from "./NoData";
import NoTableData from './NoTableData';
import { Bar } from 'react-chartjs-2';
import { BsZoomIn } from "react-icons/bs";
import BatteryTable_Orion from './BatteryTable_Orion';
import 'chartjs-plugin-datalabels';


let res_result = []
let orderedValuesA = [];
let orderedValuesB = [];
let orderedValuesC = [];
let orderedValuesD = [];

export default function CriticalBattery_Orion({gloablfilter, onreset}) {

  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [apiresponce, SetApiResponce] = useState([]);
  const [clickedLabel, setClickedLabel] = useState("");
  const [clickedPack, setClickedPack] = useState("");
  const [clickedPackData, setClickedPackData] = useState([]);

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_batterypack", body: { filterdata: gloablfilter} }, appyDataVehicles)
  },[gloablfilter])

  const appyDataVehicles = (data) => {
    orderedValuesA =[];
    orderedValuesB =[];
    orderedValuesC =[];
    orderedValuesD =[];

    res_result = []
    res_result = data;
    let responceA = {
      "<=26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      ">42": 0,
    };
    let responceB = {
      "<=26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      ">42": 0,
    };
    let responceC = {
      "<=26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      ">42": 0,
    };
    let responceD = {
      "<=26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      ">42": 0,
    };

    if (res_result.length !== 0) {
      let temp_result = res_result;
      let id = 0
      let newapiarray = []
      SetApiResponce(res_result)
      temp_result.map(d => {
        let valueA = d.A_Max_Cell_Temp.value;
        if (valueA != null) {
          if (valueA > 0 && valueA <= 26) {
            responceA["<=26"] = responceA["<=26"] + 1;
          } else if (valueA > 26 && valueA <= 28) {
            responceA["28"] = responceA["28"] + 1;
          } else if (valueA > 28 && valueA <= 30) {
            responceA["30"] = responceA["30"] + 1;
          } else if (valueA > 30 && valueA <= 32) {
            responceA["32"] = responceA["32"] + 1;
          } else if (valueA > 32 && valueA <= 34) {
            responceA["34"] = responceA["34"] + 1;
          } else if (valueA > 34 && valueA <= 36) {
            responceA["36"] = responceA["36"] + 1;
          } else if (valueA > 36 && valueA <= 38) {
            responceA["38"] = responceA["38"] + 1;
          } else if (valueA > 38 && valueA <= 40) {
            responceA["40"] = responceA["40"] + 1;
          } else if (valueA > 40 && valueA <= 42) {
            responceA["42"] = responceA["42"] + 1;
          } else if (valueA > 42) {
            responceA[">42"] = responceA[">42"] + 1;
          } 
        }

        let valueB = d.B_Max_Cell_Temp.value;
        if (valueB != null) {
          if (valueB > 0 && valueB <= 26) {
            responceB["<=26"] = responceB["<=26"] + 1;
          } else if (valueB > 26 && valueB <= 28) {
            responceB["28"] = responceB["28"] + 1;
          } else if (valueB > 28 && valueB <= 30) {
            responceB["30"] = responceB["30"] + 1;
          } else if (valueB > 30 && valueB <= 32) {
            responceB["32"] = responceB["32"] + 1;
          } else if (valueB > 32 && valueB <= 34) {
            responceB["34"] = responceB["34"] + 1;
          } else if (valueB > 34 && valueB <= 36) {
            responceB["36"] = responceB["36"] + 1;
          } else if (valueB > 36 && valueB <= 38) {
            responceB["38"] = responceB["38"] + 1;
          } else if (valueB > 38 && valueB <= 40) {
            responceB["40"] = responceB["40"] + 1;
          } else if (valueB > 40 && valueB <= 42) {
            responceB["42"] = responceB["42"] + 1;
          } else if (valueB > 42) {
            responceB[">42"] = responceB[">42"] + 1;
          } 
        }

        let valueC = d.C_Max_Cell_Temp.value;
        if (valueC != null) {
          if (valueC > 0 && valueC <= 26) {
            responceC["<=26"] = responceC["<=26"] + 1;
          } else if (valueC > 26 && valueC <= 28) {
            responceC["28"] = responceC["28"] + 1;
          } else if (valueC > 28 && valueC <= 30) {
            responceC["30"] = responceC["30"] + 1;
          } else if (valueC > 30 && valueC <= 32) {
            responceC["32"] = responceC["32"] + 1;
          } else if (valueC > 32 && valueC <= 34) {
            responceC["34"] = responceC["34"] + 1;
          } else if (valueC > 34 && valueC <= 36) {
            responceC["36"] = responceC["36"] + 1;
          } else if (valueC > 36 && valueC <= 38) {
            responceC["38"] = responceC["38"] + 1;
          } else if (valueC > 38 && valueC <= 40) {
            responceC["40"] = responceC["40"] + 1;
          } else if (valueC > 40 && valueC <= 42) {
            responceC["42"] = responceC["42"] + 1;
          } else if (valueC > 42) {
            responceC[">42"] = responceC[">42"] + 1;
          } 
        }

        let valueD = d.D_Max_Cell_Temp.value;
        if (valueD != null) {
          if (valueD > 0 && valueD <= 26) {
            responceD["<=26"] = responceD["<=26"] + 1;
          } else if (valueD > 26 && valueD <= 28) {
            responceD["28"] = responceD["28"] + 1;
          } else if (valueD > 28 && valueD <= 30) {
            responceD["30"] = responceD["30"] + 1;
          } else if (valueD > 30 && valueD <= 32) {
            responceD["32"] = responceD["32"] + 1;
          } else if (valueD > 32 && valueD <= 34) {
            responceD["34"] = responceD["34"] + 1;
          } else if (valueD > 34 && valueD <= 36) {
            responceD["36"] = responceD["36"] + 1;
          } else if (valueD > 36 && valueD <= 38) {
            responceD["38"] = responceD["38"] + 1;
          } else if (valueD > 38 && valueD <= 40) {
            responceD["40"] = responceD["40"] + 1;
          } else if (valueD > 40 && valueD <= 42) {
            responceD["42"] = responceD["42"] + 1;
          } else if (valueD > 42) {
            responceD[">42"] = responceD[">42"] + 1;
          } 
        }
      })
      let orderedKeys = ["<=26", "28", "30", "32", "34", "36", "38", "40", "42", ">42"];
      
      orderedKeys.forEach(key => {
        orderedValuesA.push(responceA[key]);
      });

      const allZeroA = orderedValuesA.every(value => value === 0);
      let maxIndexA;

      if (allZeroA) {
        maxIndexA = null;
      } else {
        maxIndexA = orderedValuesA.reduce((maxIdx, currentValue, currentIndex, array) => {
          return currentValue > array[maxIdx] ? currentIndex : maxIdx;
        }, 0);
      }

      // const maxIndexA = orderedValuesA.reduce((maxIdx, currentValue, currentIndex, array) => {
      //   return currentValue > array[maxIdx] ? currentIndex : maxIdx;
      // }, 0);
      
      orderedKeys.forEach(key => {
        orderedValuesB.push(responceB[key]);
      });

      const allZeroB = orderedValuesB.every(value => value === 0);
      let maxIndexB;

      if (allZeroB) {
        maxIndexB = null;
      } else {
        maxIndexB = orderedValuesB.reduce((maxIdx, currentValue, currentIndex, array) => {
          return currentValue > array[maxIdx] ? currentIndex : maxIdx;
        }, 0);
      }

      // const maxIndexB = orderedValuesB.reduce((maxIdx, currentValue, currentIndex, array) => {
      //   return currentValue > array[maxIdx] ? currentIndex : maxIdx;
      // }, 0);
      
      orderedKeys.forEach(key => {
        orderedValuesC.push(responceC[key]);
      });

      const allZeroC = orderedValuesC.every(value => value === 0);
      let maxIndexC;

      if (allZeroC) {
        maxIndexC = null;
      } else {
        maxIndexC = orderedValuesC.reduce((maxIdx, currentValue, currentIndex, array) => {
          return currentValue > array[maxIdx] ? currentIndex : maxIdx;
        }, 0);
      }

      // const maxIndexC = orderedValuesC.reduce((maxIdx, currentValue, currentIndex, array) => {
      //   return currentValue > array[maxIdx] ? currentIndex : maxIdx;
      // }, 0);

      orderedKeys.forEach(key => {
        orderedValuesD.push(responceD[key]);
      });

      const allZeroD = orderedValuesD.every(value => value === 0);
      let maxIndexD;

      if (allZeroD) {
        maxIndexD = null;
      } else {
        maxIndexD = orderedValuesD.reduce((maxIdx, currentValue, currentIndex, array) => {
          return currentValue > array[maxIdx] ? currentIndex : maxIdx;
        }, 0);
      }
      
      // const maxIndexD = orderedValuesD.reduce((maxIdx, currentValue, currentIndex, array) => {
      //   return currentValue > array[maxIdx] ? currentIndex : maxIdx;
      // }, 0);

      onreset(maxIndexA, maxIndexB, maxIndexC, maxIndexD)
    }else{
      onreset(null, null, null, null)
    }
  }

  const data = {
        labels: ["<=26", "28", "30", "32", "34", "36", "38", "40", "42", ">42"],
        datasets: [
          {
            label: 'Pack A',
            backgroundColor: '#184165',
            borderWidth: 1,
            data: orderedValuesA,
            barPercentage: 1,
          },
          {
            label: 'Pack B',
            backgroundColor: '#02559b',
            borderWidth: 1,
            data: orderedValuesB,
            barPercentage: 1,
          },
          {
            label: 'Pack C',
            backgroundColor: '#53749D',
            borderWidth: 1,
            data: orderedValuesC,
            barPercentage: 1,
          },
          {
            label: 'Pack D',
            backgroundColor: '#83a3ce',
            borderWidth: 1,
            data: orderedValuesD,
            barPercentage: 1,
          },
        ],
  };

    const options1 = {
      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          display: false // Hide the legend
        },
        tooltip: {
          enabled: false // Disable tooltip
        }
      },
      scales: {
        x: {
            barThickness: 'flex', // Set barThickness to 'flex' for no gap between bars in a dataset
            title: {
              display: true,
              text: '°(C)',
              minValue: 0,
              format: 'short',
              direction: 1,
              slantedText: true,
              slantedTextAngle: 90,
              font: {
                size: 11
              }
            }
        },
        y: {
          title: {
            display: true,
            text: 'Vehicle Count',
            minValue: 0,
            format: 'short',
            direction: 1,
            slantedText: true,
            slantedTextAngle: 90,
            font: {
              size: 11
            }
          }
        }
    },
    maintainAspectRatio: false,
    };
    // const options1 = {
    //     scales: {
    //       x: {
    //           barThickness: 'flex', // Set barThickness to 'flex' for no gap between bars in a dataset
    //       },
    //   },
    //     maintainAspectRatio: false
    // };

    // const options = {
    //     scales: {
    //       x: {
    //           barThickness: 'flex', // Set barThickness to 'flex' for no gap between bars in a dataset
    //       },
    //   },
    //   maintainAspectRatio: false,
    //   onClick: (event, elements) => handleBarClick(event, elements),
    // };

    const options = {
      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          display: false // Hide the legend
        },
        tooltip: {
          enabled: false // Disable tooltip
        }
      },
      scales: {
        x: {
            barThickness: 'flex', // Set barThickness to 'flex' for no gap between bars in a dataset
            title: {
              display: true,
              text: '°(C)',
              minValue: 0,
              format: 'short',
              direction: 1,
              slantedText: true,
              slantedTextAngle: 90,
              font: {
                size: 11
              }
            }
        },
        y: {
          title: {
            display: true,
            text: 'Vehicle Count',
            minValue: 0,
            format: 'short',
            direction: 1,
            slantedText: true,
            slantedTextAngle: 90,
            font: {
              size: 11
            }
          }
        }
    },
    maintainAspectRatio: false,
    onClick: (event, elements) => handleBarClick(event, elements),
  };

    const handleBarClick = (event, elements) => {
        setClickedPackData([]);
        if (elements.length > 0) {
          const barIndex = elements[0].index;
          const datasetIndex = elements[0].datasetIndex;
          const label = data.labels[barIndex];
          setClickedLabel(label)
          const legend = data.datasets[datasetIndex].label;
          let pack = legend.charAt(legend.length - 1);
          setClickedPack(pack)
          fetchData({ url: API_URL_MAIN + "critical_vehicles_orion_fleet/critcal_batterypopup", body: { filterdata: gloablfilter, PackLabel:pack} }, popup_responce)
        }
    };

    const [temp, settemp] = useState([])
    const popup_responce = (data) =>{
      settemp(data)
    }

    useEffect(() => {
      let clickedpackdata = []
      let packdata = clickedPack + "_Max_Cell_Temp";
      
      if (clickedLabel === '<=26' && temp.length > 0) {
        clickedpackdata = temp.filter(item => {
          let valueB = item[packdata].value;
          return valueB != null && valueB > 0 && valueB <= 26;
        });
      }else if(clickedLabel === '>42' && temp.length > 0){
        clickedpackdata = temp.filter(item=>{
          let value = item[packdata].value;
          return value !== null && value > 42;
        });
      }else{
        let startbucket = parseInt(clickedLabel) -2
        let endbucket = parseInt(clickedLabel) 
        clickedpackdata = temp.filter(item=>{
          let value = item[packdata].value;
          return value !== null && value > startbucket && value <= endbucket;
        });
      }

      setClickedPackData(clickedpackdata);
    }, [temp]);

    useEffect(()=>{
      if (clickedPackData.length >0) {
        window.$('#batterytable').modal('show');
      }
    },[clickedPackData])
    

  return (
    <>
      <div className="modal fade" id={"zoom_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Battery Pack Max Tempereature</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((orderedValuesA.length > 0 || orderedValuesB.length > 0 || orderedValuesC.length > 0 || orderedValuesD.length > 0) ? 
                <Bar options={options1} data={data} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="chargingChartboxNew2_Bus">
          <div className="v-title chargingTitleChart_Bus_fleet">
          <div className="row p-0">
          <div className="col-md-11">
            <div className="text-fit">Battery Pack Max Tempereature</div>
          </div>
          <div className="col-md-1 pt-2">
          <strong className="Zoom_first_page" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#zoom_modal"}> <BsZoomIn /> </strong>
          </div>
        </div>
          </div>
          <div className="tableContent_Bus px-2 mt-4" style={{ height: '248px' }}>
            <WaterMark />
            {
            (isLoading) ? <ChartLoader /> :(orderedValuesA.length > 0 || orderedValuesB.length > 0 || orderedValuesC.length > 0 || orderedValuesD.length > 0) ? 
            <Bar
                data={data}
                width={100}
                height={50}
                options={options}
            /> 
            : <NoData />
            }
          </div>
      </div>

      <div className="modal fade" id="batterytable" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Pack {clickedPack}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              {clickedPackData.length > 0 &&
              <BatteryTable_Orion data={clickedPackData} clickedPack={clickedPack} />
            }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
